// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"72":"bf8f4636","592":"2c7e3834","828":"92b8cb33"}[chunkId] + ".chunk.js";
};